import { useSelector, useDispatch } from "react-redux";
import uiActions from "../../redux/ui/action";

const useAuthUtils = () => {
  const dispatch = useDispatch();

  const { token, tokenType, classId, targetId, courseId } = useSelector(
    (state) => ({
      token: state.auth.authToken,
      tokenType: state.auth.tokenType,
      classId: state.auth.user.class_id,
      targetId: state?.userPreference?.targetDetails?.[0]?.target_id,
      courseId: state?.userPreference?.courseDetails?.[0]?.course_id,
    })
  );

  const startLoading = () => {
    dispatch(uiActions.startLoading());
  };

  const finishLoading = () => {
    dispatch(uiActions.finishLoading());
  };

  const headers = {
    Authorization: `${tokenType} ${token}`,
  };

  return { classId, targetId, courseId, headers, startLoading, finishLoading };
};

export default useAuthUtils;
